export const getGasLimits = state => state.app.gasLimits;

export const getPayContractAddress = ({ app: { payContractAddress } }) => payContractAddress;

export const getCatTokenContractAddress = ({ app: { catTokenContractAddress } }) =>
  catTokenContractAddress;

export const getCspcAddress = ({ app: { catPaymentContractAddress } }) => catPaymentContractAddress;



// WEBPACK FOOTER //
// ./src/selectors/app.js